<button class="text-btn" (click)="dialogRef.close('unmatch')" i18n="Text for the button to unmatch the user in the profile dialog@@UNMATCH">
  Unmatch
</button>
<button class="text-btn" (click)="dialogRef.close('block')" i18n="Text for the button to block the user in the profile dialog@@BLOCK_USER">
  Block the User
</button>
<button class="text-btn" (click)="dialogRef.close('report')" i18n="Text for the button to block and report the user in the profile dialog@@BLOCK_REPORT_USER">
  Block and Report the User
</button>
